import React, { useEffect } from "react";
import { View, FlatList } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import ChatUserMembersSection from "../../../../Components/chat-common-components/ChatUserMembersSection";
import NoChatFound from "../../../../Components/chat-common-components/NoChatFound";
import EventHeader from "../../../../Components/chat-common-components/EventHeader";
import Separator from "../../../../Components/Separator";
import { useChat } from "../../../../context/ChatContext";

interface ChatConversationProps {
  screenName: string;
  conversationId?: string;
}

const ChatConversation: React.FC<ChatConversationProps> = ({
  screenName,
  conversationId,
}) => {
  const styles = useStyles();
  const { chats, currentChat, openChat } = useChat();

  const sortedChats = chats
    ? screenName === "OnGoingEventsChat"
      ? chats
          .filter((chat) => chat.conversationId.toString() === conversationId)
          .sort(
            (a, b) =>
              (b.lastMessageTimestamp || 0) - (a.lastMessageTimestamp || 0)
          )
      : chats
          .filter((chat) => chat.type === "single" || chat.type === "group")
          .sort(
            (a, b) =>
              (b.lastMessageTimestamp || 0) - (a.lastMessageTimestamp || 0)
          )
    : [];

  return (
    <View style={styles.mainContainer}>
      <View style={{ flex: 1 }}>
        {screenName === "OnGoingEventsChat" && <EventHeader />}
        <Separator
          color={AppColors.grayColor_999999}
          marginHorizontal={15}
          height={2}
          marginTop={20}
          marginBottom={20}
          width="auto"
        />
        {chats && chats.length > 0 ? (
          <FlatList
            data={sortedChats}
            keyExtractor={(item) => item.conversationId}
            renderItem={({ item }) => (
              <ChatUserMembersSection
                item={item}
                isSelected={currentChat?.conversationId === item.conversationId}
                onPress={() => openChat(item.conversationId)}
              />
            )}
          />
        ) : (
          <NoChatFound />
        )}
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      paddingHorizontal: "2%",
      paddingTop: "2.5%",
    },
    mainContainer: {
      marginLeft: 20,
      backgroundColor: AppColors.gray_1F1F1F,
      borderRadius: 10,
      borderColor: AppColors.grayColor_282828,
      borderWidth: 1,
      marginHorizontal: 10,
      margin: 15,
      flex: 0.5,
      flexDirection: "row",
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      container: {
        paddingHorizontal: "3.5%",
      },
      mainContainer: {
        flex: 1,
        marginLeft: 0,
        marginRight: 0,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        flex: 0.7,
        marginLeft: 0,
        marginRight: 0,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        flex: 0.7,
        marginLeft: 0,
        marginRight: 0,
      },
    },
    [DEVICE_SIZES.LG]: {
      mainContainer: {
        flex: 0.7,
      },
    },
  }
);

export default ChatConversation;
